import { useEffect, type ReactNode } from "react";
import "./admin-visual-shell.css";

/** Presentation only: administrative permissions remain in the existing guards. */
export default function AdminVisualShell({ children }: { children: ReactNode }) {
  useEffect(() => {
    document.documentElement.classList.add("admin-visual-active");
    return () => document.documentElement.classList.remove("admin-visual-active");
  }, []);
  return <div className="admin-visual-shell min-h-dvh bg-background text-foreground">{children}</div>;
}